<nb-select placeholder="Tipo de cultivo" (selectedChange)="changeSelect()" fullWidth name="cultivo" [(ngModel)]="currentValue">
  <nb-option [value]="item.nombre" *ngFor="let item of cultivos">{{item.nombre}}</nb-option>
</nb-select>
